if (!customElements.get('product-slider-thumbnails')) {
  class ProductSliderThumbnails extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('change', this.setupProductGallery);
    }
    connectedCallback() {
      this.product_container = this.closest('.thb-product-detail');
      this.thumbnail_container = this.product_container.querySelector('.product-thumbnail-container');
      this.video_containers = this.querySelectorAll('.product-single__media-external-video--play');
      this.hide_variants = this.dataset.hideVariants == 'true';
      this.thumbnails = this.thumbnail_container.querySelectorAll('.product-thumbnail');
      this.slides = this.querySelectorAll('.product-images__slide');

      this.init();
    }
    init() {
      // Show all active slides as a vertical list
      this.slides.forEach((slide) => {
        if (slide.classList.contains('is-active')) {
          slide.style.display = 'block';
        }
      });

      // Video play buttons
      this.video_containers.forEach((container) => {
        container.querySelector('button').addEventListener('click', function () {
          container.setAttribute('hidden', '');
        });
      });

      // Thumbnail click → scroll to image
      setTimeout(() => {
        let active_thumbs = Array.from(this.thumbnails).filter(el => el.clientWidth > 0);
        active_thumbs.forEach((thumbnail, index) => {
          thumbnail.addEventListener('click', () => {
            this.thumbnailClick(thumbnail, index);
          });
        });
      });

      // Observe which slide is in view and highlight its thumbnail
      this.setupScrollObserver();

      // Setup zoom
      this.setupProductGallery();
    }
    setupScrollObserver() {
      this.dots = this.closest('.product-image-container') ? this.closest('.product-image-container').querySelectorAll('.product-slide-dots .dot') : [];
      const mobileQuery = window.matchMedia('(max-width: 1067px)');

      const initObservers = () => {
        if (this._mobileObserver) this._mobileObserver.disconnect();
        if (this._desktopObserver) this._desktopObserver.disconnect();

        // Mobile: horizontal swipe dots
        if (mobileQuery.matches) {
          this._mobileObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                const activeSlides = Array.from(this.querySelectorAll('.product-images__slide.is-active'));
                const index = activeSlides.indexOf(entry.target);
                if (index > -1) {
                  this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
                }
              }
            });
          }, { root: this, threshold: 0.5 });

          this.slides.forEach((slide) => {
            if (slide.classList.contains('is-active')) this._mobileObserver.observe(slide);
          });
        } else {
          // Desktop: vertical scroll — track which image is in viewport
          const headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height') || '80', 10);
          this._desktopObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                const activeSlides = Array.from(this.querySelectorAll('.product-images__slide.is-active'));
                const index = activeSlides.indexOf(entry.target);
                if (index > -1) {
                  this.thumbnails.forEach(t => t.classList.remove('is-initial-selected'));
                  const active_thumbs = Array.from(this.thumbnails).filter(el => el.classList.contains('is-active'));
                  if (active_thumbs[index]) {
                    active_thumbs[index].classList.add('is-initial-selected');
                    const thumb = active_thumbs[index];
                    if (thumb.offsetParent) {
                      thumb.parentElement.scrollTo({
                        top: thumb.offsetTop - thumb.offsetParent.clientHeight / 2 + thumb.clientHeight / 2,
                        behavior: 'smooth'
                      });
                    }
                  }
                }
              }
            });
          }, { root: null, rootMargin: `-${headerHeight + 20}px 0px -50% 0px`, threshold: 0 });

          this.slides.forEach((slide) => {
            if (slide.classList.contains('is-active')) this._desktopObserver.observe(slide);
          });
        }
      };

      // Delay desktop observer slightly to avoid initial fire selecting wrong thumbnail
      setTimeout(() => initObservers(), 100);
      mobileQuery.addEventListener('change', () => setTimeout(() => initObservers(), 100));
    }
    thumbnailClick(thumbnail, index) {
      this.thumbnails.forEach(t => t.classList.remove('is-initial-selected'));
      thumbnail.classList.add('is-initial-selected');

      const activeSlides = Array.from(this.querySelectorAll('.product-images__slide.is-active'));
      if (activeSlides[index]) {
        const headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height') || '80', 10);
        const top = activeSlides[index].getBoundingClientRect().top + window.scrollY - headerHeight - 20;
        window.scrollTo({ top, behavior: 'smooth' });
      }
    }
    reInit() {
      this.slides = this.querySelectorAll('.product-images__slide');
      this.thumbnails = this.thumbnail_container.querySelectorAll('.product-thumbnail');
      this.slides.forEach((slide) => {
        slide.style.display = slide.classList.contains('is-active') ? 'block' : 'none';
      });
      this.setupScrollObserver();
    }
    selectCell(mediaId) {
      const slide = this.querySelector(mediaId);
      if (slide) {
        const headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height') || '80', 10);
        const top = slide.getBoundingClientRect().top + window.scrollY - headerHeight - 20;
        window.scrollTo({ top, behavior: 'smooth' });
      }
    }
    setDraggable() {}
    setupProductGallery() {
      if (!this.querySelectorAll('.product-single__media-zoom').length) {
        return;
      }
      this.setEventListeners();
    }
    buildItems() {
      this.activeImages = Array.from(this.querySelectorAll('.product-images__slide.is-active .product-single__media-image'));
      return this.activeImages.map((item) => {
        let index = [].indexOf.call(item.parentNode.parentNode.children, item.parentNode);
        let activelink = item.querySelector('.product-single__media-zoom');
        activelink.dataset.index = index;
        return {
          src: activelink.getAttribute('href'),
          msrc: activelink.dataset.msrc,
          w: activelink.dataset.w,
          h: activelink.dataset.h
        };
      });
    }
    setEventListeners() {
      this.links = this.querySelectorAll('.product-single__media-zoom');
      this.pswpElement = document.querySelectorAll('.pswp')[0];
      this.pswpOptions = {
        maxSpreadZoom: 2,
        loop: false,
        allowPanToNext: false,
        closeOnScroll: false,
        showHideOpacity: false,
        arrowKeys: true,
        history: false,
        captionEl: false,
        fullscreenEl: false,
        zoomEl: false,
        shareEl: false,
        counterEl: true,
        arrowEl: true,
        preloaderEl: true,
        getThumbBoundsFn: () => {
          const thumbnail = this.querySelector('.product-images__slide.is-active'),
            pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect();
          return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
        }
      };
      this.links.forEach((link => {
        link.addEventListener('click', (e) => this.zoomClick(e, link));
      }));
    }
    zoomClick(e, link) {
      this.items = this.buildItems();
      this.pswpOptions.index = parseInt(link.dataset.index, 10);
      if (typeof PhotoSwipe !== 'undefined') {
        let pswp = new PhotoSwipe(this.pswpElement, PhotoSwipeUI_Default, this.items, this.pswpOptions);
        pswp.listen('firstUpdate', function () {
          pswp.listen('parseVerticalMargin', function (item) {
            item.vGap = { top: 50, bottom: 50 };
          });
        });
        pswp.init();
      }
      e.preventDefault();
    }
  }
  customElements.define('product-slider-thumbnails', ProductSliderThumbnails);
}
